import React from "react";

const DeleteBusinessGroupImpactNotice = ({ attachedBusinessGroupCount, onViewBusinessGroups, isSinglePosition = false }) => {
  const hasSingleBusinessGroup = attachedBusinessGroupCount === 1;
  const businessGroupLabel = hasSingleBusinessGroup ? "business group" : "business groups";
  const selectedPositionLabel = isSinglePosition ? "position" : "positions";
  const pronoun = isSinglePosition ? "it" : "them";
  const assignedPositionLabel = isSinglePosition ? "this position" : "these positions";

  const introText = isSinglePosition
    ? "The selected position is currently attached to"
    : "The selected positions are currently attached to";
  const deleteText = `Deleting this ${pronoun} will trigger the following actions. Are you sure ?`;
  const detachText = isSinglePosition
    ? "Position will be unattached from all"
    : "Positions will be unattached from all";

  return (
    <div className="delete-business-group-impact-notice">
      <div className="delete-business-group-impact-notice__intro">
        {attachedBusinessGroupCount > 0 ?
        <>
        {introText} {attachedBusinessGroupCount} {businessGroupLabel}. {deleteText}
        </>
        :
        <>
        Are you sure you want to delete this record?
        </>
        }
      </div>
      <div className="delete-business-group-impact-notice__card">
        <div className="delete-business-group-impact-notice__row">
          <i className="far fa-trash-alt delete-business-group-impact-notice__icon delete-business-group-impact-notice__icon--danger"></i>
          <div className="delete-business-group-impact-notice__card-description delete-business-group-impact-notice__card-description--no-margin">
            <span className="delete-business-group-impact-notice__highlight">
            Results associated with this position will also be deleted.
            </span>{" "}
       
          </div>
        </div>
      </div>
      {attachedBusinessGroupCount > 0 &&
      <>
      <div className="delete-business-group-impact-notice__card">
        <div className="delete-business-group-impact-notice__row">
          <i className="fas fa-unlink delete-business-group-impact-notice__icon delete-business-group-impact-notice__icon--warning"></i>
          <div>
            <div className="delete-business-group-impact-notice__card-title">
              {detachText} {attachedBusinessGroupCount} {businessGroupLabel}.
            </div>
            <div className="delete-business-group-impact-notice__card-description">
              {hasSingleBusinessGroup ? "The business group" : "Business groups"} with other remaining{" "}
              {selectedPositionLabel} will be kept intact.
            </div>
          </div>
        </div>
      </div>
      <div className="delete-business-group-impact-notice__card">
        <div className="delete-business-group-impact-notice__row">
          <i className="far fa-trash-alt delete-business-group-impact-notice__icon delete-business-group-impact-notice__icon--danger"></i>
          <div className="delete-business-group-impact-notice__card-description delete-business-group-impact-notice__card-description--no-margin">
            <span className="delete-business-group-impact-notice__highlight">
              {hasSingleBusinessGroup ? "A business group" : "Business groups"} with only {assignedPositionLabel} assigned
              will be automatically deleted,
            </span>{" "}
            as {hasSingleBusinessGroup ? "it" : "they"} cannot exist without an assigned position.
          </div>
        </div>
      </div>
    
      <button
        type="button"
        onClick={onViewBusinessGroups}
        className="delete-business-group-impact-notice__view-link"
      >
        <i className="far fa-building delete-business-group-impact-notice__building-icon"></i>
        View attached {businessGroupLabel} ({attachedBusinessGroupCount})
      </button>
      </>}
    </div>
  );
};

export default DeleteBusinessGroupImpactNotice;
